// extracted by mini-css-extract-plugin
export default {"labelRow":"PunchupFieldLabel_labelRow__pw2Dr","help":"PunchupFieldLabel_help__c01rI"};